import { render, staticRenderFns } from "./DefaultLogin.vue?vue&type=template&id=27b98444&lang=pug&"
import script from "./DefaultLogin.vue?vue&type=script&lang=ts&"
export * from "./DefaultLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports